import { useSelector } from "react-redux";
import { RootReducer } from "RootReducer";
import { useSuperAdmin } from "./useSuperAdmin";
import { useUserPermissions } from "./useUserPermissions";

// Partners let into the Optimize tab ahead of the general release. Hardcoded on
// purpose: the list is short, hand-picked, and changes by us, not by the backend.
const ALLOWED_PARTNER_IDS = [
  830, 808, 579, 209, 134, 819, 1118, 1475, 725, 1473, 964, 1232, 973, 899, 938,
  578, 113, 396, 442, 724, 795, 974, 1107, 1110, 1168, 168, 649, 794, 1025,
  1061, 1233, 1344, 1438, 1565, 547, 1137, 580, 1578,
];

// First-release gate for the Optimize tab (Florian): visible to account
// manager ("am") and admin ("main") accounts — the same specialMode signal
// that already gates /events — plus the internal preview allowlist, so the
// team's own test accounts keep access regardless of their account type, plus
// the partner allowlist above.
export const useOptimizeAccess = () => {
  const { isLoaded, isSuperAdmin } = useSuperAdmin();
  const { isSpecialMode } = useUserPermissions();
  const partnerId = useSelector(
    (state: RootReducer) => state.authentication.accountInfo?.partnerId
  );

  const isAllowedPartner =
    partnerId !== undefined &&
    partnerId !== null &&
    ALLOWED_PARTNER_IDS.includes(Number(partnerId));

  return {
    isLoaded,
    hasOptimizeAccess: isSuperAdmin || isSpecialMode || isAllowedPartner,
  };
};
